import { render, staticRenderFns } from "./iconDisplay.vue?vue&type=template&id=c85d1c4a&"
import script from "./iconDisplay.vue?vue&type=script&lang=js&"
export * from "./iconDisplay.vue?vue&type=script&lang=js&"
import style0 from "./iconDisplay.vue?vue&type=style&index=0&id=c85d1c4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports